import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-full-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("h2", { class: "secondary-font mb-6" }, "Transactions carte", -1),
    _createElementVNode("p", { class: "text-grey-600" }, "Historique des transactions de votre carte.", -1),
    _createElementVNode("div", { class: "clear-both h-60" }, null, -1)
  ]))]))
}